export interface ErrorLocation {
  path: string;
  line: number; // 1-based
}

const JS_FRAME_RE = /([\w./-]+\.(?:js|jsx|ts|tsx)):(\d+)(?::\d+)?/g;
const PY_FRAME_RE = /File "([^"]+\.py)", line (\d+)/g;

/** Best-effort extraction of file:line references from a stack trace or error message pasted into the prompt. */
export function parseErrorLocations(text: string): ErrorLocation[] {
  const locations: ErrorLocation[] = [];
  for (const m of text.matchAll(JS_FRAME_RE)) locations.push({ path: m[1], line: parseInt(m[2], 10) });
  for (const m of text.matchAll(PY_FRAME_RE)) locations.push({ path: m[1], line: parseInt(m[2], 10) });
  return locations;
}

function basename(path: string): string {
  return path.split('/').pop() ?? path;
}

/** Matches a stack-trace path against a project-relative path by suffix or basename — stack traces rarely use the exact same relative form as our virtual project paths. */
export function matchesPath(projectPath: string, errorPath: string): boolean {
  return projectPath.endsWith(errorPath) || errorPath.endsWith(projectPath) || basename(projectPath) === basename(errorPath);
}
